import { defaultFont } from 'ha/constants/fonts/default';
import { sourceSansHeaders as sharpSansHeadersFont } from 'ha/constants/fonts/sourceSansHeaders';

export const ACTIVE_FONTS = [defaultFont, sharpSansHeadersFont];
